import config from './config'
import init from './init'

import Vue from 'vue'
import router from './router'
import App from './App'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VueLazyload from 'vue-lazyload'
import Toast from './framework/CYZS.Toast'

import './config/HttpHelper'
import './filters'
// import './transitions';
import './directives'

import ImageComponent from 'COMMON/imageComponent'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'font-awesome/css/font-awesome.css'
init(config)
// 非开发版本安装sentry
if (process.env.NODE_ENV != 'development') {
  Raven
    .config('https://58b9c89954544becb2d84b804bb33b2e@sentry.io/157588')
    .addPlugin(RavenVue, Vue)
    .install()
}

Vue.use(VueLazyload)
Vue.use(ImageComponent)
Vue.use(ElementUI)
Vue.prototype.$message = Toast.show.bind(Toast)
Vue.config.productionTip = false
Vue.config.devtools = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') ? false : true
new Vue({
  el: '#app',
  router: router,
  ...App
})
